import { PickupParticipantListPage } from "components/shared/pickupParticipants";

export const PickupSportParticipantList: React.FC = () => (
  <PickupParticipantListPage kind="sport" variant="admin" />
);
